import { Intl } from "Roblox";
import notificationStreamModule from "../notificationStreamModule";

function developerMetricsAvailable($window, gameUpdatesService, notificationStreamUtility, urlService, $log) {
    "ngInject";

    function getMonthName(month) {
        var months = new Intl().getMonthsList('long');
        for (var i = 0, len = months.length; i < len; i++) {
            if (months[i].value === month) {
                return months[i].name;
            }
        }
        return "";
    }

    return {
        restrict: "A",
        replace: true,
        scope: {
            notification: "=",
            appMeta: "=",
            library: "=",
            interactNotification: "&"
        },
        templateUrl: notificationStreamUtility.templates.developerMetricsAvailableTemplate,
        link: function (scope, element, attrs) {
            var init = function () {
                scope.notificationSourceType = notificationStreamUtility.notificationSourceType;
                scope.developerMetricsAvailableLayout = {
                    month: "",
                    year: "",
                    universeId: -1,
                    gameName: "",
                    gameNameLinked: "",
                    rootPlaceId: -1,
                    gameLinkUrl: null,
                    gameIconUrl: null
                }
                var metaData = scope.notification.metadataCollection;
                if (metaData && metaData.length > 0) {
                    var validData = metaData[0];
                    var url = urlService.getAbsoluteUrl("/places/" + validData.rootPlaceId + "/stats");
                    scope.developerMetricsAvailableLayout.month = getMonthName(validData.month);
                    scope.developerMetricsAvailableLayout.year = validData.year;
                    scope.developerMetricsAvailableLayout.universeId = validData.universeId;
                    scope.developerMetricsAvailableLayout.gameName = validData.gameName;
                    scope.developerMetricsAvailableLayout.gameNameLinked = '<a class="text-name font-caption-header" href=\"' + url + '\">' + validData.gameName + '</a>';
                    scope.developerMetricsAvailableLayout.rootPlaceId = validData.rootPlaceId;
                    scope.developerMetricsAvailableLayout.gameLinkUrl = url;
                    gameUpdatesService.multiGetGameIconsAsync([validData.universeId]).then(
                        function (gameIcons) {
                            if (!gameIcons || !gameIcons.hasOwnProperty(validData.universeId)) {
                                return;
                            }

                            scope.developerMetricsAvailableLayout.gameIconUrl = gameIcons[validData.universeId];
                        }
                    );

                    // Handler to launch game when view button is clicked.
                    scope.viewButtonHandler = function () {
                        $window.location.href = scope.developerMetricsAvailableLayout.gameLinkUrl;
                    };
                }
            }

            init();
        }
    }
}

notificationStreamModule.directive("developerMetricsAvailable", developerMetricsAvailable);

export default developerMetricsAvailable;